type InputWord = string | null | undefined;
export function capitalizeFirstLetter(word: InputWord, defaultString = '--'): string {
  if (typeof word === 'string') {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  return defaultString;
}

export function splitAtCapitalLetters(word: InputWord, defaultString = '--'): string {
  if (typeof word === 'string') {
    return word
      .split(/(?=[A-Z])/)
      .map((e) => capitalizeFirstLetter(e))
      .join(' ');
  }

  return defaultString;
}

export function convetToTitleCase(word: InputWord, defaultString = ''): string {
  if (typeof word === 'string') {
    return word
      .split('_')
      .map((e) => capitalizeFirstLetter(e))
      .join(' ');
  }

  return defaultString;
}
